import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f57a042"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status-container", $props.status === 'noNetwork' ? 'status-container--nonetwork' : 'status-container--default'])
  }, [_createElementVNode("img", {
    class: "status-img",
    src: $setup.statusImg
  }, null, 8, _hoisted_1), _createElementVNode("div", {
    class: "status-text font-14-regular",
    innerHTML: $setup.statusText
  }, null, 8, _hoisted_2), _renderSlot(_ctx.$slots, "more", {}, undefined, true)], 2);
}